import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { WooCommerceUserInfoResponse } from '../models/woocommerce-user.model';
import { WooCommerceService } from '../services/woocommerce.service';

/**
 * Resolver que precarga la user-info de la tienda antes de activar la ruta.
 * Así la caché está llena cuando el componente y el header se crean, y no hay parpadeo.
 * Si la petición falla, resuelve con null para que la ruta se active igual y la página pueda mostrar error.
 */
@Injectable({ providedIn: 'root' })
export class StoreUserInfoResolver implements Resolve<WooCommerceUserInfoResponse | null> {
  constructor(private woocommerceService: WooCommerceService) {}

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<WooCommerceUserInfoResponse | null> {
    return this.woocommerceService.getStoreUserInfo().pipe(
      take(1),
      catchError(() => of(null))
    );
  }
}
